import * as React from "react";
function SvgReply(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M31 29v-8A12 12 0 0019 9H1M1 9l6-6M7 15L1 9" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgReply);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
